module.exports = __webpack_public_path__ + "static/media/25.3144849f.wav";